<template>
  <div class="avatar-uploader-box">
    <div class="avatar-uploader-bg">
      <el-upload
        class="avatar-uploader"
        :action="actionUrl"
        :data="{ disk: typeImg }"
        :headers="headerInfo"
        :show-file-list="false"
        :on-progress="uploading"
        :on-success="handleUploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeImageUpload"
        accept="image/*"
        name="file"
        v-loading="upLoading"
      >
        <p class="delete-bar" v-if="image" @click.stop="handleRemove">
          <i class="el-icon-close"></i>
        </p>
        <img class="avatar" v-if="image" :src="image" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
// import { server } from '@/config/index'
// import Cookies from 'js-cookie'
import { server } from '@/http'
import { getCookie } from '@/utils/cookie'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    imgType: {
      type: String,
      default: 'box'
    },
    // widthNum: {
    //   type: String,
    //   default: '100px'
    // },
    // heightNum: {
    //   type: String,
    //   default: '100px'
    // }
  },
  data() {
    return {
      upLoading: false,//上传图片加载动画
    }
  },
  computed: {
    headerInfo() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    actionUrl() {
      return `${server}file`
    },
    image() {
      return this.value
    },
    typeImg() {
      return this.imgType
    },
  },
  created() {
  },
  methods: {
    beforeImageUpload(file) {
      //图片上传之前的回调
      //配置/验证上传图片格式、大小
      // let isJPG = false;
      // switch (file.type) {
      //   case "image/png":
      //     isJPG = true;
      //     break;
      //   case "image/jpg":
      //     isJPG = true;
      //     break;
      //   case "image/jpeg":
      //     isJPG = true;
      //     break;
      //   default:
      //     isJPG = false;
      //     break;
      // }

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // return isJPG && isLt2M;

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploading() {
      //上传图片中的回调
      this.upLoading = true

    },
    handleUploadSuccess(res) {
      //上传成功的回调
      this.upLoading = false
      if (res.path) {
        this.$emit('input', res.path)
      } else {
        this.$message.error('上传失败')
      }
      if (this.$parent.$refs['form']) {
        this.$parent.$refs['form'].validateField('image')
      }
    },
    handleRemove() {
      //移除图片
      this.$emit('input', '')
    },
    uploadError() {
      // 上传失败
      this.upLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
.avatar-uploader-box {
  display: flex;
  align-items: center;
  .avatar-uploader-bg {
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    .avatar-uploader {
      width: 100px;
      min-height: 100px;
      border-radius: 6px;
      cursor: default !important;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        border-color: #409eff;
      }
      .el-upload {
        position: relative;
        .delete-bar {
          position: absolute;
          right: -25px;
          top: -8px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding: 3px;
          height: 30px;
          width: 60px;
          transform: rotate(45deg);
          background-color: rgba(248, 94, 94, 0.8);
          &:hover {
            .el-icon-close {
              transform: rotate(315deg);
            }
          }

          .el-icon-close {
            transition: all 0.3s;
            transform: rotate(45deg);
            color: #fff;
          }
        }

        .avatar {
          width: 100%;
          height: auto;
          display: block;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }
      }
    }
  }
}
</style>
